import { useTranslation } from "react-i18next";

export const useLocalizedPath = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.substring(0, 2) || "en";

  const localizedPath = (path: string) => {
    if (path.startsWith("/en/") || path.startsWith("/fr/")) {
      return path;
    }
    return `/${lang}${path === "/" ? "" : path}`;
  };

  return { localizedPath, lang };
};
